import { render } from "./DoctorInfo.vue?vue&type=template&id=60029147"
import script from "./DoctorInfo.vue?vue&type=script&lang=js"
export * from "./DoctorInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__